export default __webpack_public_path__ + "static/media/temp-6.da651abb.svg";